import { sendEvent } from './lib';

/**
 * flights_hot_offers_page_opened - Открыл страницу страны с горящим билетом
 */
export const hotOffersPageOpened = (params: {
  cityFrom: string;
  countryName: string;
}) => {
  sendEvent('flights_hot_offers_page_opened', {
    city_from: params.cityFrom,
    country_name: params.countryName,
  });
};

/**
 * travel_my_tickets_page_open - Открыл страницу "Мои билеты"
 */
export const myTicketsPageOpen = (params: { sourceScreen: string | null }) => {
  sendEvent('travel_my_tickets_page_open', {
    source_screen:
      params.sourceScreen === 'main_page'
        ? 'flights_main_page'
        : 'flights_menu_sidebar',
  });
};
